<template>
    <li>
        <a :href="link" class="item_list" target="_blank">
            <div class="thumb_g"><img :src="profileImage" width="54" height="54" alt=""></div>
            <div class="desc_list">
                <strong class="tit_list">{{ title }}</strong>
                <p class="txt_list">{{ description }}</p>
                <span class="info_list">방문 {{ homeVisitCnt.toLocaleString() }}</span>
                <span class="info_list">회원 {{ memberCount.toLocaleString() }}</span>
            </div>
        </a>
    </li>
</template>

<script>
export default {
    props: {
        link: String,
        title: String,
        description: String,
        profileImage: String,
        memberCount: {
            type: Number,
            default: 0
        },
        homeVisitCnt: Number
    }
}
</script>
